import isString from 'lodash-es/isString';
export function getRequiredValue(valueName, object) {
    const value = object[valueName];
    if (value !== undefined) {
        return value;
    }
    throw new Error(`Expected required configuration variable, ${valueName}`);
}
export function getRequiredStringValue(valueName, object) {
    const value = getRequiredValue(valueName, object);
    if (isString(value)) {
        return value;
    }
    throw new Error(`Expected required string configuration variable, ${valueName}`);
}
//# sourceMappingURL=ConfigurationHelpers.js.map